import { Components, Theme } from "@mui/material";

export const MuiDialogContent: Components<Theme>["MuiDialogContent"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: 30,
      [theme.breakpoints.down("sm")]: {
        padding: 15,
      },
    }),
  },
};
